import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ModalModule, SimpleMessageModule, LayoutModule } from '@allbesmart/web-app-common';

@Component({
    selector: 'oaibox-root',
    template: `
  <router-outlet></router-outlet>
  <oaibox-modal-outlet></oaibox-modal-outlet>
  <oaibox-simple-message-outlet></oaibox-simple-message-outlet>
  <oaibox-cookies-consent></oaibox-cookies-consent>
  `,
    imports: [RouterOutlet, ModalModule, SimpleMessageModule, LayoutModule]
})
export class AppComponent {

  constructor() { }

}
